// src/utils/jsonParser.ts

/**
 * Common JSON parser utility for API responses
 * Handles both string and object responses safely
 */
export const parseApiResponse = <T>(data: unknown): T => {
  let parsedData = data;
  
  if (data && typeof data === 'string' && (data as string).trim() !== '') {
    try {
      parsedData = JSON?.parse(data as string);
    } catch (error) {
      parsedData = data;
    }
  }
  
  return parsedData as T;
};
